<template>
    <v-layout row>
      <v-menu class="customSearchBoxWrapper" :close-on-content-click="false" :open-on-click="false" :close-on-click="false" :allow-overflow="true" :offset-y="true" :full-width="true">
        <div slot="activator" class="customSearchCompany elevation-4">
          <v-menu bottom :close-on-click="true" :disabled="!countries || countries.length <= 1">
            <template v-slot:activator="{ on, attrs }">
              <div id="countryselector" class="customCountrySelector" align-center v-bind="attrs" v-on="on">
                <span class="customSelectorContent">
                  <span class="customFlagImageCountrySearch">
                    <v-img class="customFlagImageCountrySearch" :src="getCurrentCountryFlag()" :alt="getCurrentCountryCode()"/>
                  </span>
                  <span class="customSearchCountrytext" align-center v-text="getCurrentCountryCode()"></span>
                  <i v-if="countries && countries.length > 1" aria-hidden="true" class="v-icon material-icons theme--light error--text customSearchArrowDropDown">arrow_drop_down</i>
                </span>
              </div>
            </template>
            <v-list>
              <template v-for="(item, index) in countries">
                <v-hover v-slot:default="{ hover }" :key="index">
                  <v-list-tile class="customCountrySelectionItem" :class="hover ? 'elevation-2' : ''" @click="changeCountry(item)">
                    <v-list-tile-action class="pa-1">
                      <v-img class="customFlagImageCountrySearch" :src="item.flag" :alt="item.code"/>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <v-list-tile-title>{{ item.code }}</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-hover>
              </template>
            </v-list>
          </v-menu>
        </div>
      </v-menu>
      <v-flex xs5 class="searchbox">
              <div class="inlinebox">
                <v-text-field ref="inputBox" v-model="value.identifierValue" :rules="searchRules" :placeholder="searchPlaceHolder" class="searchbuyerinput" @keydown.enter="triggerSearch" clearable @click:clear="clearSearchBox" @update:error="errorChanged"></v-text-field>
              </div>
      </v-flex>
    </v-layout>
</template>

<script>
import { mapState } from 'vuex'
import coverApi from '@/services/CoverApi'
export default {
  data () {
    return {
      valid: true,
      selectedCountryFlag: ''
    }
  },
  props: ['value', 'hasError'],
  async mounted () {
    if (this.$isEmpty(this.value.identifierCountryCode)) {
      this.value.identifierCountryCode = this.getCurrentCountryCode()
      this.value.identifierTypeCode = (await coverApi.getPrincipalIdentifierForCountry(this.value.identifierCountryCode)).IdentifierCode
    }
  },
  methods: {
    async clearSearchBox () {
      this.value.identifierValue = ''
      this.$emit('search')
    },
    async changeCountry (country) {
      this.selectedCountryFlag = country.flag
      this.value.identifierCountryCode = country.code
      this.value.identifierTypeCode = (await coverApi.getPrincipalIdentifierForCountry(this.value.identifierCountryCode)).IdentifierCode
      await this.clearSearchBox()
    },
    triggerSearch () {
      if (!this.inputHasError) {
        this.$emit('search')
      }
    },
    getCurrentCountryCode () {
      return !this.$isEmpty(this.value.identifierCountryCode) ? this.value.identifierCountryCode : this.customerCountry.code
    },
    getCurrentCountryFlag () {
      return this.selectedCountryFlag ? this.selectedCountryFlag : this.customerCountry.flag
    },
    errorChanged (val) {
      this.$emit('update:hasError', val)
    }
  },
  computed: {
    searchRules: function () {
      let countryRules = []
      this.principalIdentifierRules.filter((u) => {
        if (!!this.value && !this.$isEmpty(this.value.identifierTypeCode) && this.value.identifierTypeCode.toUpperCase() === u.principalIdentifier.toUpperCase()) {
          countryRules = u.rules
        }
      })
      return countryRules
    },
    searchPlaceHolder: function () {
      return this.$t('Cover.ListCover.SEARCH_BUYER_PLACEHOLDER')
    },
    countries: function () {
      if (!this.userInfos || !this.countriesWithFlag || !this.userInfos.allowedCountriesForCoverage || !this.config.newCoverAllowedCountries) {
        return []
      }
      let siteConfigAllowedCountries = this.config.newCoverAllowedCountries.toUpperCase().split(',')
      let userAllowedCountries = this.userInfos.allowedCountriesForCoverage ? this.userInfos.allowedCountriesForCoverage.filter(uc => siteConfigAllowedCountries.some(sc => sc.toUpperCase() === uc.toUpperCase())) : []

      // add at least the customer's country
      if (!userAllowedCountries.some(c => c.toUpperCase() === this.userInfos.country.toUpperCase())) {
        userAllowedCountries.push(this.userInfos.country.toUpperCase())
      }

      let countriesWithFlag = this.countriesWithFlag.filter(cf => userAllowedCountries.some(c => c.toUpperCase() === cf.countryCode.toUpperCase()))
      let result = userAllowedCountries.map(c => {
        return {
          code: c,
          flag: countriesWithFlag.find(f => f.countryCode.toUpperCase() === c.toUpperCase()).countryFlag
        }
      })
      return result
    },
    customerCountry: function () {
      let country = this.countries.find(c => c.code === this.userInfos.country)
      return country
    },
    ...mapState('userdetails', ['customerCountryPrincipalIdentifier', 'userInfos']),
    ...mapState('countries', ['principalIdentifierRules']),
    ...mapState('countries', ['countriesWithFlag']),
    ...mapState('siteconfig', ['config'])
  }
}
</script>

<style>
.customSearchBoxWrapper {
  width: 30px;
  margin-top: 18px;
  margin-left: 15px;
}
.customSearchCompany {
  display: inline-flex;
  width: 90px;
  height: 4px;
  background-color: #fcfdfd;
  border-radius: 4px;
}
.customSearchCompany > .v-menu__content {
  min-width: 87px;
}
.customCountrySelector {
  background-color: #fcfdfd;
  width: 90px;
  height: 40px;
  border-bottom-left-radius: 4px;
  border-top-left-radius: 4px;
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: var(--primary-color);
  border-bottom: 1px solid #e8e8e8;
}
.customCountrySelectionItem {
  color: var(--primary-color);
  cursor: pointer;
}
.customCountrySelectionItem:hover {
  background-color: #f0f0f0;
}
.customCountrySelectionItem > .v-list__tile {
  height: 36px;
  padding: 0px 7px;
}

.customCountrySelectionItem > .v-list__tile > .v-list__tile__action {
  min-width: 48px !important;
}
.customSelectorContent{
  margin-left: 16px;
  margin-top: 10px;
  display: flex;
}
.customSelectorContent > .theme--light.v-icon {
   color: var(--primary-color) !important;
}
.customFlagImageCountrySearch{
    width: 24px;
    max-width: 24px;
    height: 18px;
    max-height: 18px;
    object-fit: contain;
}
.customSearchCountrytext{
   margin-left: 7px;
}
.customSearchArrowDropDown{
  font-size: 20px;
}
.v-autocomplete__content.v-menu__content {
    max-width: 464px;
}
.v-menu__content {
  border-top-left-radius: 0px !important;
  border-top-right-radius: 0px !important;
  margin-top: -2px;
}

</style>
